<!--待支付  -->
<template>
  <div class="unpaidIndent">
    <div style="height:100%">
      <HandselEntrance ref="Handsel" />
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :immediate-check="false"
          :offset="20"
          v-if="isData"
          @load="onLoad"
        >
          <div class="card" v-for="(item, index) in unpaidList" :key="index">
            <div class="card-header">
              <div class="card-header-first">
                <div class="left">{{ filtersStatus(item.status) }}</div>
                <div class="right" v-if="item.countDown">
                  <span class="count">{{ item.countDown }}</span>
                  <span>后自动取消</span>
                </div>
              </div>
            </div>
            <div class="card-body" @click="courseDetails(item.orderNo)">
              <div
                class="public"
                v-for="(course, index) in item.orderPackageProductRespList || item.orderProductList"
                :key="index"
              >
                <div class="text">
                  <p class="name">
                    <i
                      v-if="course.productName.substr(0, 1) == '【'"
                      class="title-special-processing"
                    />{{ course.productName }}
                  </p>
                </div>
                <span class="pice">￥{{ course.productPrice }}</span>
              </div>
              <!-- <div class="public">
              <div class="text">
                <span>协议</span>
                <p class="deal">
                考研直播课程名称考研直播程名称考研直播课程名称考研直播程名称
                </p>
              </div>
              <span class="pice">￥2000</span>
            </div>
            <div class="public">
            <div class="text">
              <span>增值</span>
              <p class="deal">
                考研直播课程名称考研直播程名称考研直播课程名称考研直播程名称
                </p>
              </div>
            <span class="pice">￥2000</span>
          </div> -->
            </div>
            <div class="card-footer">
              <div class="pay">
                <span>下单时间 {{ item.createTime }}</span>
                <div class="money">
                  <span
                    ><p>{{ filtersPayText(item.status) }}</p>
                    <p class="pice">￥{{item.channel==45?0:item.partnerOrder?item.orderTotalAmount:item.orderAmount}}</p></span
                  >
                </div>
              </div>
              <div class="button">
                <div class="cancel" @click="cancelOrder(item.orderNo)">取消订单</div>
                <div class="payment" @click="payOrder(item.orderNo)">立即支付</div>
              </div>
            </div>
          </div>
        </van-list>
        <EmptyData :emptyName="'noIndent'" v-else />
      </van-pull-refresh>
    </div>
    <DiaLog ref="logShow" :logType="'unpaidIndent'" :orderID="orderID" @clearUnList="clearUnList" />
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import { reqOrderList } from '@/api/personal/orderController';
import { invalidTimeCount } from '@/utils/tools';
import EmptyData from '@/components/emptyData/emptyData.vue';
import DiaLog from '../components/diaLog.vue';
import { orderType, selectPayText } from '../indentTools';
import HandselEntrance from '../components/handselEntrance.vue';

export default {
  data() {
    return {
      orderParam: {
        pageNum: 1,
        pageSize: 5,
        status: '1',
      },
      unpaidList: [],
      unpaidTotal: 0,
      orderID: '',
      loading: true,
      finished: false,
      refreshing: false,
      isData: true,
    };
  },

  components: {
    EmptyData,
    DiaLog,
    HandselEntrance,
  },

  computed: {},

  mounted() {},

  created() {
    this.getUnpaidList(this.orderParam);
  },

  methods: {
    // 每次向下滚动，滚动条与底部距离小于offset时触发
    onLoad() {
      if (this.unpaidList.length >= this.unpaidTotal) {
        // 如果没有数据需要加载了就显示没有更多了
        this.finished = true;
      } else {
        // 如果发现现有数组并没有达到总条数则加页继续发送请求
        clearInterval(this.timer);
        this.timer = null;
        this.orderParam.pageNum += 1;
        this.getUnpaidList(this.orderParam);
      }
    },
    // 下拉刷新
    onRefresh() {
      this.refreshing = true;
      this.clearOrderList();
      this.$refs.Handsel.getHandsel();
    },
    // 清除缓存重新请求
    clearOrderList() {
      // this.unpaidList = [];
      this.orderParam.pageNum = 1;
      this.loading = false;
      this.finished = false;
      this.getUnpaidList(this.orderParam);
    },
    async getUnpaidList(data) {
      try {
        const res = await reqOrderList(data);
        if (res.code === 0) {
          if (this.refreshing) {
            this.unpaidList = [];
          }
          if (res.data.total === 0) {
            this.isData = false;
          }
          this.refreshing = false;
          this.loading = false;
          res.data.data.forEach((item) => {
            const { orderPackageProductRespList } = item;
            (orderPackageProductRespList || []).forEach((child) => {
              Object.assign(child, { productName: child.packageName, productPrice: child.price });
            });
          });
          this.unpaidList.push(...res.data.data);
          this.unpaidTotal = res.data.total;
          this.transferTimeList(this.unpaidList);
        } else {
          this.$toast(`请求失败！${res.msg}`);
        }
      } catch (error) {
        this.$toast(error.message);
      }
    },
    // 等待支付倒计时
    transferTimeList(list) {
      const that = this;
      this.timer = setInterval(() => {
        list.forEach((item) => {
          const Obj = item;
          // 只有待支付状态有倒计时
          if (Obj.status === 1 && Obj.payTimeout !== 0) {
            // 倒计时为0刷新数据
            if (Obj.payTimeout === 0) {
              clearInterval(that.timer);
              this.clearOrderList();
            }
            Obj.payTimeout -= 1;
            Obj.countDown = invalidTimeCount(Obj.payTimeout);
            that.$set(that.unpaidList, Obj.countDown, invalidTimeCount(Obj.payTimeout));
          }
        });
      }, 1000);
    },
    // 订单状态
    filtersStatus(status) {
      return orderType(status);
    },
    filtersPayText(status) {
      return selectPayText(status);
    },
    // 取消订单
    cancelOrder(id) {
      this.$refs.logShow.show = true;
      this.orderID = id;
    },
    // 取消弹窗确认取消重新请求数据
    clearUnList() {
      this.unpaidList = [];
      this.clearOrderList();
    },
    // 立即支付
    payOrder(orderNumber) {
      if (this.$root.$data.isApp) {
        this.$sendToApp('payCenter', { orderNo: orderNumber }, false);
        return;
      }
      if (this.$root.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/myCourse/cashier/cashier?orderNo=${orderNumber}`,
        });
        return;
      }
      this.$router.push({
        path: '/cashier',
        query: {
          orderNo: orderNumber,
        },
      });
    },
    // 进入详情页
    courseDetails(orderNo) {
      this.$router.push({ path: '/indentDetail', query: { orderNo } });
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>
<style lang="scss" scoped>
@import '@/style/indentCard.scss';
.unpaidIndent {
  height: 100%;
  .left {
    color: $theme_color;
  }
}
</style>
